
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Drancy dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Drancy certifiée Google Partner, accompagne les entreprises drancéennes pour améliorer leur visibilité en ligne et capter davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Drancy dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Drancy certifiée Google Partner, accompagne les entreprises drancéennes pour améliorer leur visibilité en ligne et capter davantage de prospects.",
        },
      ],
    };
  },
};
